//export const BASE_URL_API = 'http://localhost:8081/php/';
export const BASE_URL_API = 'https://www.bigwavedevelopment.com/php/';
export const BASE_URL_API2 = 'http://www.bigwavedevelopment.com:2020/';
export const BASE_URL_IMAGE = 'https://www.bigwavedevelopment.com/';